import React from 'react'
// import LoaderButton from './LoaderButton'
// import FormViewer from './FormViewer'
import { checkPermission, checkTranslation, chooseWallpaper, getObject, getPermissionObject, imageAddress, setObject, translate } from "../utils/useful";
// import Responsive from './Responsive';
// import TableViewer from './TableViewer';
// import SwitchInput from './inputs/SwitchInput';
// import StageActionButton from '../../components/partials/StageActionButton';
import AddPermissionModal from '../modals/AddPermissionModal';
import SearchUsersModal from '../modals/SearchUsersModal';
import SearchGroupsModal from '../modals/SearchGroupsModal';
// import SidebarView from './SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import ActionButton from './partials/ActionButton';
// import CAHeader from './header/CAHeader';
// import ButtonAnimated from './buttons/ButtonAnimated';
// import TextInput from './inputs/TextInput';
import { nanoid } from 'nanoid';
// import SelectInput from './inputs/SelectInput';
import Collapsible from 'react-collapsible';
// import CheckboxInput from './inputs/CheckboxInput';
// import FilterEditorInput from './inputs/FilterEditorInput';
// import RadiusSelectInput from './inputs/RadiusSelectInput';
import HelpButton from './HelpButton';
import PermissionsSidebarView from './PermissionsSidebarView';
import { v4 as uuidv4 } from "uuid";
import HttpServices from '../utils/Http.services';

class PermissionsView extends React.Component {
    state = {

        // actions: {
        //     edit: { key: "edit", label: "{{lang}}ca.Edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
        //     remove: { key: "remove", label: "{{lang}}ca.Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        // },

        customAccess: {},

        collapses: {},

        currentType: 'admins',

        frames: [],

        tabsView: {},

        admins: [],
        users: [],
        public: true,

        permissionsObject: {},


    }

    componentDidMount() {
        this.permissionsToObject()
        this.getAppletRoles()

    }

    componentDidUpdate(prevProps) {
        if (prevProps.admins != this.props.admins) {

            this.permissionsToObject()

            if (!this.state.allRoles || this.state.allRoles.length == 0) {
                this.getAppletRoles()
            }
        }
    }



    getAppletRoles = () => {


        // console.log("getAppletRoles")
        // console.log(this.props.variables)


        if (this.props.variables?.appletId) {

            let body = { applet: this.props.variables?.appletId }

            this.setState({ isLoadingRoles: true })
            HttpServices.request('getAppletRoles', body, (fetchResult, fetchError) => {

                // console.log("getAppletRoles", fetchResult)

                this.setState({ isLoadingRoles: false })

                if (fetchError) {
                    return
                }

                this.setState({ allRoles: fetchResult.info })
            })

        } else {
            if (Array.isArray(this.props.admins)) {
                let allRoles = this.props.admins.filter((a) => a.type == 'role')

                this.setState({ allRoles })
            }

        }

    }



    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }


    // openAddAccess = () => {

    //     this.setState({ currentRole: null }, () => {
    //         this.addPermissionModal.open()
    //     })

    // }


    openAddAdmin = (item, type, customAccess) => {
        // let groupsInitData = []
        // let hubsInitData = []
        let groups
        let hubs

        let customList = this.props.admins ? this.props.admins.filter((a) => a.type != 'role') : []
        let rolesList = this.props.admins ? this.props.admins.filter((a) => a.type == 'role') : []


        if (item != null) {
            groups = item?.groups
            hubs = item?.hubs
            // console.log(groups)
            // console.log(hubs)
            // if (groups) {
            //     groups.forEach(element => {
            //         groupsInitData.push(element._id)
            //     });
            // }
            // if (hubs) {
            //     hubs.forEach(element => {
            //         hubsInitData.push(element._id)
            //     });
            // }
        } else {

            hubs = []
            groups = []

            customList.forEach(admin => {
                if (Array.isArray(admin.hubs)) {
                    admin.hubs.forEach(hub => {
                        hubs.push(hub)
                    })
                }

                if (Array.isArray(admin.groups)) {
                    admin.groups.forEach(group => {
                        groups.push(group)
                    })
                }
            });

        }

        let permissionInitTab = customAccess ? 'hubs' : null

        // console.log(item)

        this.setState({ currentType: type, permissionInitTab, currentRole: item, groupsInitData: groups, hubsInitData: hubs, rolesInitData: rolesList }, () => {
            this.addPermissionModal.open()
        })
    }


    permissionTypeSelected = (type) => {
        if (type == 'users') {
            this.searchUsersModal.showModal()
        } else {
            this.searchGroupsModal.showModal()
        }
    }


    addRole = () => {
        let currentItemIndex
        let currentType = 'admins'
        let list = this.props[currentType]
        let allRoles = this.state.allRoles
        // let listType = 'admins'

        let admins = this.props.admins
        if (!admins) {
            admins = []
        }
        let roleName = 'Role ' + admins.length ?? 1

        // list.push({ name: roleName, id: nanoid(), permissions: '*' })

        let newRole = { name: roleName, type: 'role', id: nanoid(), _id: uuidv4(), permissions: [] }


        if (Array.isArray(this.props.frames)) {
            this.props.frames.forEach(frame => {
                newRole.permissions.push({ id: frame._id ?? frame.id, type: 'frame', access: '*' })
            });
        }

        list.push(newRole)


        currentItemIndex = list.length - 1

        let item = list[currentItemIndex]

        allRoles.push(newRole)


        this.setAdmins(list, () => {
            setTimeout(() => {
                this.permissionsToObject(() => {
                    this.openPermissions(item, currentItemIndex, currentType)
                    this.setState({ allRoles })

                })
            }, 10);

        })


    }



    setAdmins = (list, cb) => {

        let finalAdmins = JSON.parse(JSON.stringify(list))

        // if (Array.isArray(finalAdmins)) {

        //     finalAdmins.forEach((mAdmin, i) => {
        //         let hubs = []
        //         if (Array.isArray(mAdmin.hubs)) {

        //             mAdmin.hubs.forEach(hub => {
        //                 hubs.push(hub?._id ?? hub)
        //             });

        //         }

        //         let groups = []
        //         if (Array.isArray(mAdmin.groups)) {

        //             mAdmin.groups.forEach(group => {
        //                 groups.push(group?._id ?? group)
        //             });

        //         }
        //         finalAdmins[i].hubs = hubs
        //         finalAdmins[i].groups = groups

        //     });

        // }

        this.props.setAdmins(finalAdmins, cb)
    }



    onNewUsersSelected = (users, type, cb) => {

        // console.log('users, type', users, type)
        let list = [...this.props.admins]
        let currentRole = this.state.currentRole


        let currentItemIndex
        // console.log('list', list)
        if (currentRole) {
            list.forEach((admin, j) => {
                if (admin.id == currentRole.id) {
                    currentItemIndex = j
                }
            })
        }

        // console.log('currentItemIndex', list)

        if (currentItemIndex != null) {

            list[currentItemIndex].hubs = []
            list[currentItemIndex].groups = []

            users.forEach(user => {

                let listType = user.type + 's'

                if (listType != 'roles') {

                    list[currentItemIndex][listType].push({ ...user })
                }
            })


        } else {
            console.log('users')
            users.forEach(user => {

                let listType = user.type + 's'

                let found = false
                let hubsInitData = this.state.hubsInitData ?? []
                let groupsInitData = this.state.groupsInitData ?? []
                let admins = this.props.admins ?? []

                for (let index = 0; index < hubsInitData.length; index++) {
                    const element = hubsInitData[index];
                    if (user._id == element._id) {
                        found = true

                    }
                }

                for (let index = 0; index < groupsInitData.length; index++) {
                    const element = groupsInitData[index];
                    if (user._id == element._id) {
                        found = true
                    }
                }

                for (let index = 0; index < admins.length; index++) {
                    const element = admins[index];
                    if (user._id == element._id || ((!user._id || !element._id) && (user.id == element.id))) {
                        found = true
                    }
                }

                if (!found) {


                    let newRole = { [listType]: [user], type: 'custom', id: nanoid(), _id: (user?._id ?? user), permissions: [] }
                    if (user.type == 'role') {
                        newRole = { hubs: user.hubs ?? [], groups: user.groups ?? [], name: user.name, type: 'role', id: user.id, _id: user._id, permissions: [] }
                    }

                    if (Array.isArray(this.props.frames)) {
                        this.props.frames.forEach(frame => {
                            newRole.permissions.push({ id: frame._id ?? frame.id, type: 'frame', access: '*' })
                        })
                    }

                    list.push(newRole)
                }

            });
            if (users.length == 1) {
                currentItemIndex = list.length - 1
            }

        }

        let item = list[currentItemIndex]

        // console.log("LIST", list)
        this.setAdmins(list, () => {
            this.permissionsToObject(() => {
                if (currentItemIndex != null && !currentRole) {
                    this.openPermissions(item, currentItemIndex, this.state.currentType)
                }
            })
        })
        this.setState({ hubsInitData: [], groupsInitData: [] }, () => {
        })
        if (cb) {
            cb()
        }
    }


    revokePermission = (item, i, type) => {

        if (!item.locked) {
            let list = this.props.admins

            let index

            list.forEach((admin, j) => {
                if (admin.id == item.id) {
                    index = j
                }
            })

            if (index != null) {
                list.splice(index, 1)
                this.setAdmins(list, () => {
                    this.permissionsToObject(() => { })
                })
            }

        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("The list which includes the owner can not be removed") })
        }

    }

    removePermission = (item, i, type) => {
        if (!item.locked) {
            let list = this.props.admins
            let allRoles = this.state.allRoles ?? []

            let index
            let roleIndex

            list.forEach((admin, j) => {
                if (admin.id == item.id) {
                    index = j
                }
            })

            allRoles.forEach((role, j) => {
                roleIndex = j
            });


            if (index != null) {
                list.splice(index, 1)

                this.setAdmins(list, () => {
                    this.permissionsToObject(() => { })
                })
            }

            if (roleIndex != null) {
                allRoles.splice(roleIndex, 1)
                this.setState({ allRoles })
            }


        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("The list which includes the owner can not be removed") })
        }
    }

    openPermissions = (item, i, type) => {

        // console.log("openPermissions")
        // console.log(index)
        let list = this.props.admins
        let index

        list.forEach((admin, j) => {
            if (admin.id == item.id) {
                index = j
            }
        });

        if (index != null) {

            // console.log(this.permissionSidebarView)
            this.permissionSidebarView.open()

            let listHasOwner = false

            if (item?.hubs && Array.isArray(item.hubs)) {
                item.hubs.forEach(element => {
                    if (element.owner == true) {
                        listHasOwner = true
                    }
                });

            }

            this.setState({ currentType: type, isMainAccess: item?.mainAccess, currentItem: item, listHasOwner, currentItemIndex: index })

        } else {

        }
    }


    showPermissionsText = (permissions) => {
        let text = ''

        if (permissions == '*') {
            text = translate("Full Access")
        } else {
            text = Object.values(permissions).length + translate(' Permissions')
            if (Object.values(permissions).length == 0) {
                text = translate("No Permissions, Will be removed")
            }
        }

        return text
    }


    infoView(admin, user, index, type, isRole) {
        return (
            <div className='flexc py-0 w-100 ' style={{ borderBottom: '0px solid #f2f2f2' }}>

                {!isRole && (
                    <ActionButton>
                        <div className=" mt-0  pt-2 pb-1 px-3 d-flex flex-column w-100 " style={{ minWidth: 180, boxShadow: '0px 0px 50px #10101050', backgroundColor: '#fff', borderRadius: 6 }}>

                            {/* <button onClick={() => { this.removePermission(user, index, 'admins') }} className="w-100 p-0 mt-2 mb-2 text-start flexc" >
                                <img src='/assets/icons/useful/flow-1.png' height={14} />
                                <p className="text-smaller mx-1">{translate('Change Role')}</p>
                            </button> */}


                            {!user.mainAccess && (
                                <button onClick={() => { this.removeUserFromPermission(admin, user, type, index) }} className="w-100 p-0 mt-1 text-start flexc mb-2" >
                                    <img src='/assets/icons/useful/trash.png' height={14} />
                                    <p className="text-smaller mx-1">{translate('Remove from role')}</p>

                                </button>
                            )}


                        </div>
                    </ActionButton>
                )}

                <div className='mx-2 flexcc'>
                    {user.type == 'group' || user.type == 'groups' ? (
                        <img className='task-check-img' src={'/images/icons/comunities.png'} height={28} width={28} style={{ borderRadius: 20 }} />
                    ) : (
                        <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={28} width={28} style={{ borderRadius: 20 }} />
                    )}
                </div>

                <div className='flexc flex-1'>

                    <div>
                        {isRole ? (
                            <button onClick={() => this.openPermissions(admin, index, 'admins')}><p className='task-title  text-small text-semibold  cursor-pointer'>{user.fullname ?? user.name}</p></button>
                        ) : (
                            <p className='task-title  font-size-13 text-semibold  cursor-pointer'>{user.fullname ?? user.name}</p>
                        )}
                        <p className='task-title  text-smallest  cursor-pointer' style={{ color: '#666' }}>{user.username ? ("@" + user.username) : translate("Group")}</p>
                    </div>
                    {/* <div className='flexc'>
                           <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mt-1 '>Username</p>
                      </div> */}

                    {user.owner && (
                        <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
                            <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
                        </div>
                    )}

                </div>
            </div>
        )
    }


    // permissionInfoView(admin,user, type, index) {
    //     return (
    //         <div className='flexcb mb-1 pb-1' style={{ borderBottom: '1px solid #f6f6f6' }}>


    //             <div className='flexc'>
    //                 <div className='mld-2 mrd-3 flexcc'>

    //                     {user.type == 'group' ? (
    //                         <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />

    //                     ) : (
    //                         <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
    //                     )}
    //                 </div>

    //                 <div className='d-flex flex-column  flex-1'>
    //                     <div className='flexc'>
    //                         <p className='task-title  text-small  '>{user.fullname ?? user.name}</p>
    //                         {user.owner && (
    //                             <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
    //                                 <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
    //                             </div>
    //                         )}
    //                     </div>
    //                     {user.username && (
    //                         <p className='task-title  text-smaller  '>{user.username}</p>

    //                     )}

    //                     {user.type == 'group' && (
    //                         <p className='task-title  text-smaller color-gray-2 '>{translate('ca.group')}</p>

    //                     )}
    //                 </div>
    //             </div>

    //             {!user.owner && (
    //                 <button onClick={() => this.removeUserFromPermission(admin,user, type, index)} className='mx-2  flexcc' style={{ backgroundColor: '#eee', borderRadius: 20, width: 18, height: 18 }}>
    //                     <img className='opacity-5' src={'/assets/icons/close.svg'} height="14px" />
    //                 </button>
    //             )}

    //         </div>
    //     )
    // }

    // editRoleName = (key, value, extra) => {

    //     let list = this.props.admins
    //     // let admin = list[extra.index]
    //     list[this.state.currentItemIndex].name = value

    //     this.setState({ [this.state.currentType]: list })

    // }



    removeUserFromPermission = (refAdmin, user, type, index) => {
        let currentType = this.state.currentType ?? 'admins'

        // return
        let list = this.props.admins
        let currentItemIndex

        list.forEach((admin, j) => {
            if (admin.id == refAdmin.id) {
                currentItemIndex = j
            }
        });
        // console.log(list[this.state.currentItemIndex])
        list[currentItemIndex][type].splice(index, 1)

        this.setAdmins(list, () => {
            this.permissionsToObject(() => { })
        })
        // this.setState({ [this.state.currentType]: list })
    }



    // changeAccess = (frame, permission, value, headers) => {


    //     let list = this.props.admins
    //     // let list = admins
    //     let admin = list[this.state.currentItemIndex]
    //     let permissions = admin?.permissions ?? []
    //     let framePermission
    //     let framePermissionIndex



    //     permissions.forEach((fpermission, index) => {
    //         if (fpermission.id == frame.id || fpermission._id == frame._id) {
    //             framePermission = fpermission
    //             framePermissionIndex = index
    //         }
    //     });


    //     let keys = ('access.' + permission.key).split('.')

    //     let parentKey = keys.splice(keys.length - 1, 1).join('.')


    //     framePermission.access = this.createPermissionHierarchy(framePermission, permission, keys, headers, value)


    //     let permissionValue = getPermissionObject(framePermission, parentKey).value


    //     if (permissionValue != '*' && permissionValue != null && typeof permissionValue == 'object') {


    //         let keys = typeof parentValue == 'object' ? Object.keys(permissionValue) : []
    //         let keysCount = 0
    //         keys.forEach(element => {
    //             if (!element.startsWith('*')) {
    //                 keysCount++
    //             }
    //         });

    //         if (keysCount == Object.keys(headers).length) {


    //             setObject(framePermission, parentKey, '*')

    //             // setObject(framePermission, 'access.' + '**fullAccess', '*')
    //         } else if (keysCount > 0) {
    //             setObject(framePermission, 'access.' + '**fullAccess', '-')
    //         } else {
    //             setObject(framePermission, 'access.' + '**fullAccess', null)
    //         }
    //     }


    //     list[this.state.currentItemIndex].permissions[framePermissionIndex] = framePermission

    //     // let permissionsObject = this.state.permissionsObject

    //     // console.log(framePermission)

    //     this.setState({ admins: list }, () => {
    //         this.permissionsToObject()
    //     })



    // }


    createPermissionHierarchy = (framePermission, permission, keys, headers, value) => {

        let parentKey = keys.splice(keys.length - 1, 1).join('.')

        let parentValue = getObject(framePermission, parentKey)

        let output = parentValue
        // let key = permission.key

        // let parentKeys = keys.split('.')

        // let headerParentKey = parentKey

        // parentKey = 'access.' + parentKey
        // console.log(parentKey)

        let myHeaders = getObject({ access: headers }, parentKey)


        // console.log(myHeaders)




        // console.log(parentValue)

        if (output == '*') {

            output = {}
            // setObject(output, parentKey, {})

        }

        Object.values(myHeaders).forEach(pheader => {

            if (pheader.key == permission.key) {
                // console.log(pheader.key)
                setObject(output, pheader.key, value)
            } else {
                // if (value == null) {

                // console.log(headers)
                // console.log(permission.key)
                if (value == null) {

                    if (permission.key == pheader.dependancy) {
                        // if (headers[permission.key].dependancy == pheader.key) {
                        setObject(output, pheader.key, value == null ? null : '*')
                    } else {
                        if (parentValue == '*') {
                            if (getPermissionObject(output, pheader.key).value == null) {
                                setObject(output, pheader.key, '*')
                            }
                        }
                    }
                } else {
                    // console.log('myHeaders', myHeaders)
                    if (myHeaders[permission.key].dependancy == pheader.key) {
                        if (getPermissionObject(output, pheader.key).value == null) {
                            setObject(output, pheader.key, '*')
                        }
                    }
                }

                // }
            }
        })

        return output


    }


    permissionsToObject = (cb) => {

        let admins = this.props.admins ?? []

        let permissionsObject = {}
        let permissionsLabels = {}
        let frames = this.props.frames


        // console.log('frames', frames)
        // console.log('admins', admins)

        admins.forEach(admin => {

            if (Array.isArray(admin.permissions)) {
                admin.permissions.forEach(permission => {


                    let role = admin.id

                    // console.log("permission.access",role, permission.access)

                    // console.log("ROLE",role)
                    if (!permissionsObject[role]) {
                        permissionsObject[role] = {}
                    }
                    // let id = permission?._id ?? permission?.id
                    let id = permission?.id ?? permission?._id

                    // console.log("Admin", id,permission.access)


                    permissionsObject[role][id] = permission.access


                    if (!permissionsLabels[role]) {
                        permissionsLabels[role] = {}
                    }
                    if (this.props.type == 'stage') {

                        if (permission.type != 'applet') {

                            if (!permissionsLabels[role].frames) {
                                permissionsLabels[role].frames = { view: { list: [], full: true, count: 0 }, edit: { list: [], full: true, count: 0 }, remove: { list: [], full: true, count: 0 } }
                            }
                            ['view', 'edit', 'remove'].map((type) => {

                                let isFull = false

                                frames.forEach(frame => {
                                    let frameId = frame._id ? frame._id : frame.id
                                    if (frameId == id) {
                                        let myPermission = getPermissionObject(permission.access, type)
                                        // console.log("myPermission", type, myPermission)
                                        if (myPermission?.allowed) {
                                            permissionsLabels[role].frames[type].list.push({ id: frameId, name: frame.name, full: myPermission.value !== '*' })
                                            permissionsLabels[role].frames[type].count++
                                            if (myPermission.value == '*') {
                                                isFull = true
                                            }
                                        }

                                    }
                                })

                                if (!isFull) {
                                    permissionsLabels[role].frames[type].full = false
                                }
                            })


                            // if (!foundFrame) {
                            //     permissionsLabels[role].frames.allFrames = false
                            // }
                            // console.log("admin.name", admin.name)
                            // console.log("permissionsLabels[role]", permissionsLabels[role])
                        }
                        // console.log(permissionsLabels[role].view)


                    } else {

                        if (['frame', 'hubsetting'].includes(permission.type) || !permission.type) {

                            let foundFrame = false
                            if (!permissionsLabels[role].frames) {
                                permissionsLabels[role].frames = { count: 0, full: true, allFrames: true, list: [] }
                            }
                            frames.forEach(frame => {
                                let frameId = frame._id ? frame._id : frame.id
                                if (frameId == id) {

                                    permissionsLabels[role].frames.list.push({ id: frameId, name: frame.name, access: permission.access })

                                    if (permission.access) {
                                        permissionsLabels[role].frames.count++
                                        if (permission.access != '*') {
                                            permissionsLabels[role].frames.full = false
                                        }
                                        foundFrame = true
                                    }
                                }
                            })

                            if (!foundFrame) {
                                permissionsLabels[role].frames.allFrames = false
                            }
                        } else {
                            if (!permissionsLabels[role].applet && permission.access) {
                                permissionsLabels[role].applet = { full: permission.access == '*' }
                            }
                        }
                    }


                })
            }
        });


        // console.log("permissionsLabels", permissionsLabels)
        this.setState({ permissionsObject, permissionsLabels }, () => {
            if (cb) {
                cb()
            }
        })

    }

    // fullAccessedClicked = (frame, permission) => {

    //     let list = this.props.admins
    //     let admin = list[this.state.currentItemIndex]
    //     let permissions = admin.permissions
    //     let framePermission
    //     let framePermissionIndex


    //     // console.log(permissions)

    //     permissions.forEach((fpermission, index) => {
    //         if (fpermission.id == frame.id || fpermission._id == frame._id) {
    //             framePermission = fpermission
    //             framePermissionIndex = index
    //         }
    //     })

    //     // framePermission.access = '*'

    //     let value = getPermissionObject(framePermission, 'access').value

    //     if (value == '*') {
    //         framePermission.access = {}
    //     } else {
    //         framePermission.access = '*'
    //     }

    //     list[this.state.currentItemIndex].permissions[framePermissionIndex] = framePermission

    //     this.setState({ admins: list }, () => {
    //         this.permissionsToObject()
    //     })
    // }


    // changeTabsView = (frameId, key, value) => {
    //     let tabsView = this.state.tabsView
    //     setObject(tabsView, frameId + '.' + key, value)

    //     if (key == 'showAdvanced' && value && !getObject(tabsView, frameId + '.advancedTab')) {

    //         setObject(tabsView, frameId + '.advancedTab', 'view')

    //     }
    //     this.setState({ tabsView })
    // }



    saveRoleAccess = () => {
        this.permissionSidebarView.close()
    }


    onClosed = () => {
        if (this.props.onClosed) {

            this.setState({ tabsView: {} })
            this.props.onClosed()
        }
    }


    renderLabels(permissionLabels) {
        return (
            <>

                {this.props.type != 'stage' && this.props.type != 'frame' && (
                    <div className='flexc'>
                        {/* {console.log(permissionLabels)} */}
                        {/* {permissionLabels.applet && ( */}

                        <div className='br-4 mrd-1' style={{ padding: '3px 4px', backgroundColor: permissionLabels?.applet ? (permissionLabels?.applet.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            {/* rgb(255, 197, 0) */}
                            <p className='text-smallest text-bold'>{translate("Applet")}</p>
                        </div>
                        {/* )} */}

                        {/* {permissionLabels.frames && ( */}
                        <div className='br-4' style={{ padding: '3px 4px', backgroundColor: (permissionLabels?.frames && permissionLabels?.frames?.count > 0) ? (permissionLabels?.frames.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            <p className='text-smallest text-bold'>{permissionLabels?.frames?.allFrames ? translate('All frames') : (permissionLabels?.frames?.count > 0 ? translate(`${permissionLabels?.frames?.count} Frame(s)`) : translate("No frame"))}</p>
                        </div>
                        {/* )} */}

                    </div>
                )}



                {this.props.type == 'frame' && (
                    <div className='flexc'>
                        <div className='br-4' style={{ padding: '3px 4px', backgroundColor: (permissionLabels?.frames && permissionLabels?.frames?.count > 0) ? (permissionLabels?.frames.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            <p className='text-smallest text-bold'>{permissionLabels?.frames?.full ? translate('Full access') : (permissionLabels?.frames ? translate("Partial access") : translate("No access"))}</p>
                        </div>
                    </div>
                )}

                {/* {console.log(permissionLabels?.frames)} */}
                {this.props.type == 'stage' && (
                    <div className='flexc'>

                        <div className='br-4 mrd-1' style={{ padding: '3px 4px', backgroundColor: permissionLabels?.frames?.view?.count > 0 ? (permissionLabels?.frames?.view.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            <p className='text-smallest text-bold'>{translate("View")}</p>
                        </div>

                        <div className='br-4 mrd-1' style={{ padding: '3px 4px', backgroundColor: permissionLabels?.frames?.edit?.count > 0 ? (permissionLabels?.frames?.edit.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            <p className='text-smallest text-bold'>{translate('Edit')}</p>
                        </div>

                        <div className='br-4' style={{ padding: '3px 4px', backgroundColor: permissionLabels?.frames?.remove?.count > 0 ? (permissionLabels?.frames?.remove.full ? "rgb(0, 205, 116)" : '#fc9d03') : 'rgb(238, 80, 80)', color: '#fff' }}>
                            <p className='text-smallest text-bold'>{translate('Remove')}</p>
                        </div>

                    </div>
                )}
            </>
        )
    }

    changeCollapse = (id) => {
        let collapses = this.state.collapses

        collapses[id] = !collapses[id]

        this.setState({ collapses })
    }


    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        // console.log("variables",variables)
        if (!variables.appletHub) {
            let user = this.props.initData?.hub ?? this.props.user?.info?._id
            variables.user = user
            variables.targetId = user
            variables.appletHub = user
        }
        let customList = this.props.admins ? this.props.admins.filter((a) => a.type != 'role') : []
        let rolesList = this.props.admins ? this.props.admins.filter((a) => a.type == 'role') : []

        return (

            <>

                <div className={'postition-relative flexc flex-column ' + (this.props.className ?? '')} >

                    <div className="mt-1 mb-3 w-100  pt-1" style={{ borderRadius: 4, maxWidth: this.props.maxWidth }} >
                        <div className='flexcb mb-2 pld-2 prd-2'>
                            <div className='flexc'>
                                <p className='text-normal text-bold '>{translate("Roles access")}</p>
                                {/* <HelpButton data={"Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur laudantium voluptatum ipsam eligendi consequatur rem error. Quia unde delectus quis optio iusto! Voluptatum quia inventore ut omnis quisquam pariatur? Nulla."} /> */}
                            </div>
                            <div className='flexc'>
                                <button className='br-4 px-2 py-1' onClick={() => this.addRole(null, 'admins')} style={{ border: '1px solid #007aff' }}>
                                    <p className='color-blue-1 text-smaller text-semibold'>+ {translate("Add Role")}</p>
                                </button>

                                <button className='mld-3 br-4 px-2 py-1' onClick={() => this.openAddAdmin(null, 'admins')} style={{ border: '1px solid #007aff' }}>
                                    <p className='color-blue-1 text-smaller text-semibold'>+ {translate("Add access")}</p>
                                </button>

                            </div>
                        </div>

                        <div className='bg-white' style={{ border: '1px solid #f0f0f0', boxShadow: '0px 0px 20px #00000005', borderRadius: 10 }}>
                            <div>
                                {rolesList?.length == 0 && (
                                    <div className='px-2 py-2'>
                                        <p className='text-smaller  mb-2 mx-1 mt-2 ' style={{ maxWidth: 500, color: "#aaa" }}>There is no access for any role. You can add permissions for the roles</p>
                                    </div>
                                )}

                                {rolesList?.map((role, index) => {

                                    let permissionLabels = this.state.permissionsLabels ? this.state.permissionsLabels[role.id] : null

                                    let open = this.state.collapses[role.id]
                                    if (this.props.defaultOpen) {
                                        open = !open
                                    }
                                    // console.log(this.state.permissionsLabels)
                                    // console.log(permissionLabels, role)

                                    // if (role.type == 'role') {
                                    return (
                                        <div className={'w-100 task-row mb-0 px-2 pt-2 pb-2 ' + (role.done ? ' done ' : '')} key={role.id} style={{ borderBottom: index < rolesList?.length - 1 ? '1px solid #eee' : null }}>

                                            <div className='flexcb mb-1 mx-1 mt-1'>
                                                <div className='flexc'>
                                                    <ActionButton>
                                                        <div className="  pt-2 pb-2 px-3 d-flex flex-column w-100" style={{ minWidth: 160, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                            <button onClick={() => this.openPermissions(role, index, 'admins')} className="w-100 p-0 text-start flexc mt-1 mb-1" >
                                                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                                                <p className="text-smaller text-semibold px-1  ">{translate('Edit Role')}</p>

                                                            </button>

                                                            <button onClick={() => this.openAddAdmin(role, 'admins')} className="w-100 p-0 text-start flexc mt-1 mb-1" >
                                                                <img src='/assets/icons/useful/user.png' height={15} alt='' />
                                                                <p className="text-smaller text-semibold px-1  ">{translate('Assign to role')}</p>

                                                            </button>



                                                            {/* {this.props.type == 'frame' && ( */}
                                                            <button onClick={() => this.revokePermission(role, index, 'admins')} className="w-100 p-0 mt-1 text-start flexc mb-1" >
                                                                <img src='/assets/icons/useful/forbidden.png' height={15} alt='' />
                                                                <p className="text-smaller text-semibold px-1 ">{translate('Revoke access')}</p>
                                                            </button>
                                                            {/* )} */}


                                                            {role.id != 'owner' && this.props.type != 'stage' && (
                                                                <button onClick={() => this.removePermission(role, index, 'admins')} className="w-100 p-0 mt-1 text-start flexc mb-1" >
                                                                    <img src='/assets/icons/useful/trash.png' height={15} alt='' />
                                                                    <p className="text-smaller text-semibold px-1 ">{translate('Remove Role')}</p>

                                                                </button>
                                                            )}


                                                        </div>
                                                    </ActionButton>
                                                    <button onClick={() => this.openPermissions(role, index, 'admins')}>
                                                        <p className='text-smaller  mx-2 color-gray-2'><span className='text-small text-bold color-black'>{role.name}</span>
                                                            {false && (
                                                                <span> {(role.hubs?.length > 0 || role.groups?.length > 0) ? ' - ' : translate(" - No access")} {role.hubs?.length > 0 ? translate(role.hubs?.length + " hub(s)") : ''}{(role.hubs?.length > 0 && role.groups?.length > 0) ? ' - ' : ' '}{role.groups?.length > 0 ? translate(role.groups?.length + " group(s)") : ''}</span>
                                                            )}
                                                        </p>
                                                    </button>

                                                    {!open && (
                                                        <button onClick={() => this.changeCollapse(role.id)} className='mrd-2 text-link'>
                                                            <p className='text-smaller'>{translate("Expand")}</p>
                                                        </button>
                                                    )}

                                                    {open && (
                                                        <button onClick={() => this.changeCollapse(role.id)} className='mrd-2 text-link'>
                                                            <p className='text-smaller'>{translate("Shrink")}</p>
                                                        </button>
                                                    )}

                                                </div>

                                                {this.renderLabels(permissionLabels)}


                                            </div>



                                            <Collapsible open={open} transitionTime={100}>
                                                <div className='flexcb w-100 mb-1' style={{}}>
                                                    <div className='flexc w-100 px-1'>

                                                        <div className='  w-100  px-3 '>

                                                            {(role.groups?.length > 0 || role.hubs?.length > 0) && (

                                                                <div className='mt-1 mb-2'>
                                                                    {role.hubs?.map((user, j) => {
                                                                        return (
                                                                            <div key={user._id} className='mb-1'>
                                                                                {this.infoView(role, user, j, 'hubs')}
                                                                            </div>
                                                                        )
                                                                    })}

                                                                    {role.groups?.map((user, j) => {
                                                                        return (
                                                                            <div key={user._id} className='mb-1'>
                                                                                {this.infoView(role, user, j, 'groups')}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )}

                                                            {/* {(!role.hubs || role.hubs?.length == 0) && (!role.groups || role.groups?.length == 0) && (
                                                                <div>
                                                                    <p className=' text-smaller px-2' style={{ color: '#aaa' }}>{translate('No hub or group is added to this role yet.')}</p>
                                                                </div>
                                                                     )} */}

                                                            <div className='mt-1 mx-1 flexc'>
                                                                <button className='br-4 px-0 py-1' onClick={() => this.openAddAdmin(role, 'admins')} style={{ border: '0px solid #007aff' }}>
                                                                    {/* onClick={() => this.openAddAdmin(null, 'admins')}> */}
                                                                    <p className='color-blue-1 text-semibold font-size-11'>+ {translate("Assign to role")}</p>
                                                                </button>

                                                            </div>



                                                        </div>

                                                    </div>
                                                </div>
                                            </Collapsible>


                                            <Collapsible open={!open} transitionTime={50}>
                                                {(Array.isArray(role.hubs) && role.hubs.length > 0 || (Array.isArray(role.groups) && role.groups.length > 0)) && (
                                                    <div className='flexc mb-0 scroll-no-scrollbar px-1 mt-0'>

                                                        {Array.isArray(role.hubs) && (
                                                            role.hubs.map((hub, index) => {
                                                                return (
                                                                    <div key={hub._id} className='mrd-1 flexcc ' style={{ maxWidth: 75 }}>
                                                                        <img className='task-check-img' src={imageAddress(hub.image, 'profile')} height={20} width={20} style={{ borderRadius: 20 }} alt='' />
                                                                        {/* <p className=' text-smallest text-semibold w-100 text-center mld-1 ' style={{ marginTop: 2, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{hub.fullname ?? hub.name}</p> */}
                                                                    </div>
                                                                )
                                                            })

                                                        )}

                                                        {Array.isArray(role.groups) && (
                                                            role.groups.map((group, index) => {
                                                                return (
                                                                    <div key={group._id} className='mrd-1 flexcc ' style={{ maxWidth: 75 }}>
                                                                        <img className='task-check-img' src={'/images/icons/comunities.png'} height={20} width={20} style={{ borderRadius: 20 }} alt='' />
                                                                        {/* <p className=' text-smallest text-semibold w-100 text-center mld-1 ' style={{ marginTop: 2, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{group.fullname ?? group.name}</p> */}
                                                                    </div>
                                                                )
                                                            })

                                                        )}
                                                    </div>
                                                )}

                                            </Collapsible>


                                        </div>
                                    )
                                    // }
                                })}

                            </div>
                            {rolesList?.length < this.state.allRoles?.length && !this.props.hideOtherRolesText && (
                                <div className='px-3 pb-2 pt-2' style={{ backgroundColor: '#f2f2f2', borderRadius: '0px 0px 8px 8px' }}>
                                    <p className='text-smaller' style={{ color: '#888' }}>{this.state.allRoles?.length - rolesList?.length} other applet role(s) do not have access. If you want to add access to roles, you can use the "Add access" button.</p>
                                </div>
                            )}




                        </div>

                        <div className='flexcb mx-1 mt-4 pld-2 prd-2'>
                            <div className='flexc '>
                                <p className='text-normal text-bold '>{translate("Custom access")}</p>
                                <div className='px-1'>
                                    <HelpButton data={"Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur laudantium voluptatum ipsam eligendi consequatur rem error."} />
                                </div>
                            </div>

                            {customList.length > 0 && (
                                <button onClick={() => this.openAddAdmin(null, 'admins', true)}>
                                    <p className='color-blue-1 text-smaller'>+ {translate("Add custom access")}</p>
                                </button>
                            )}
                        </div>


                        <div className={'w-100  mb-2  pt-1 bg-white br-10 mt-3 pb-1' + (this.state.customAccess.done ? ' done ' : '')} style={{ border: '1px solid #eee' }}>

                            <div className=''>

                                {customList.length == 0 && (
                                    <div className='px-2'>
                                        <p className='text-smaller  mb-2 mx-1 mt-2 ' style={{ maxWidth: 500, color: "#aaa" }}>You can use for giving custom access to any user or any group without putting them into any roles.</p>
                                    </div>
                                )}

                                <div className='flexcb w-100 mb-2' style={{}}>
                                    <div className='flexc w-100 px-1'>
                                        <div className=' task-info w-100  '>

                                            {customList?.map((item, index) => {

                                                let permissionLabels = this.state.permissionsLabels ? this.state.permissionsLabels[item.id] : null
                                                // if (item.type != 'role') {
                                                return (
                                                    <div className={'w-100 mb-0 px-2 pt-1 pb-1 ' + (item.done ? ' done ' : '')} key={item.id} style={{ borderBottom: index < customList?.length - 1 ? '1px solid #eee' : null }}>

                                                        <div className='flexcb mb-1  mt-1'>
                                                            <div className='flexc'>
                                                                <ActionButton>
                                                                    <div className="  py-2 px-3 d-flex flex-column w-100" style={{ minWidth: 160, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                                        <button onClick={() => this.openPermissions(item, index, 'admins')} className="w-100 p-0 text-start flexc mt-1 mb-2" >
                                                                            <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                                                            <p className="text-smaller text-semibold px-1  ">{translate('Edit access')}</p>
                                                                        </button>
                                                                        {item.id != 'owner' && (
                                                                            <button onClick={() => this.revokePermission(item, index, 'admins')} className="w-100 p-0 mt-1 text-start flexc mb-1" >
                                                                                <img src='/assets/icons/useful/forbidden.png' height={15} alt='' />
                                                                                <p className="text-smaller text-semibold px-1 ">{translate('Revoke access')}</p>

                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </ActionButton>

                                                                {item.hubs && item.hubs[0] && (
                                                                    <> {this.infoView(item, item.hubs[0], null, 'hubs', true)} </>
                                                                )}

                                                                {item.groups && item.groups[0] && (
                                                                    <>  {this.infoView(item, item.groups[0], null, 'groups', true)}</>
                                                                )}


                                                            </div>


                                                            {this.renderLabels(permissionLabels)}


                                                        </div>

                                                    </div>
                                                )
                                                // }
                                            })}


                                            <div className='mt-0 px-2'>
                                                <button onClick={() => this.openAddAdmin(null, 'admins', true)}>
                                                    <p className='color-blue-1 text-smaller'>+ {translate("Add custom access")}</p>
                                                </button>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>


                </div>




                {/* <SearchUsersModal actions={this.props.actions} data={this.state.hubsInitData} disableInitData={!this.state.currentRole} mainAccess={this.state.isMainAccess} ref={el => this.searchUsersModal = el} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} />
                <SearchGroupsModal actions={this.props.actions} data={this.state.groupsInitData} disableInitData={!this.state.currentRole} mainAccess={this.state.isMainAccess} ref={el => this.searchGroupsModal = el} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} /> */}
                <PermissionsSidebarView ref={(el) => this.permissionSidebarView = el} width={this.props.width} frames={this.props.frames} permissionsType={this.props.permissionsType} admins={this.props.admins} setAdmins={this.setAdmins} currentItemIndex={this.state.currentItemIndex} onClosed={() => this.onClosed()} permissionsObject={this.state.permissionsObject} setPermissionsObject={this.permissionsToObject} type={this.props.type} stage={this.props.stage} applet={this.props.applet} editModalView={this.props.editModalView} />


                <AddPermissionModal
                    isLoading={this.state.isLoadingPermission}
                    onDone={this.onNewUsersSelected}
                    ref={el => this.addPermissionModal = el}
                    allRoles={this.state.allRoles}
                    roles={this.state.rolesInitData}
                    hubs={this.state.hubsInitData}
                    groups={this.state.groupsInitData}
                    variables={variables}
                    currentRole={this.state.currentRole}
                    initTab={this.state.permissionInitTab}
                />
                {/* <AddPermissionModal
                    isLoading={this.state.isLoadingPermission}
                    onDone={this.permissionTypeSelected}
                    ref={el => this.addPermissionModal = el}
                    roles={this.props.roles}
                    hubs={this.state.hubsInitData}
                    groups={this.state.groupsInitData}
                    variables={variables}
                /> */}

            </>

        )
    }
}

// export default PermissionsView;


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PermissionsView);
